import {ManufacturingItemModel} from "../models/manufacturing-item.model";
import {instanceToInstance, Type} from "class-transformer";

export class ManufacturingItemSaveModel {
  Id: string;
  @Type(() => ManufacturingItemModel)
  Content: ManufacturingItemModel;
  ModifiedBy: string;
  ModifiedDate: Date;

  static createFromItem(item: ManufacturingItemModel, modifiedBy: string) {
    return Object.assign(new ManufacturingItemSaveModel(), {
      Id: item.Id,
      Content: instanceToInstance(item),
      ModifiedBy: modifiedBy,
      ModifiedDate: new Date
    });
  }
}
